export const imageWH = '168px'

export const specialityPath = '/for-abiturients/speciality'
